// extracted by mini-css-extract-plugin
export var actualiteTitle = "detailsContenuLibre-module--actualite-title--cebb2";
export var contenuLibreContainer = "detailsContenuLibre-module--contenu-libre-container--cff80";
export var editButton = "detailsContenuLibre-module--edit-button--c81bd";
export var pageContenuLibre = "detailsContenuLibre-module--page-contenu-libre--5ea20";